import * as Actions from "../actions/_ActionTypes";
import * as Pre from "../actions/_PreActionNames";
import * as CONSTS from "../../assets/consts";
import * as SecureStore from "../components_v2/DeviceAsyncStorage";
import AppLog from "../logger";
import { IS_MOBILE, translate } from "../locales/translate";
import Text from "../components_v2/TextFont";
import ServerInfo from "../viewModels/ServerInfo";
import checkIPAddress from "../hooks/checkIPAddress";
import { ArButton } from "../argon-ui";
import ShowCameraDoorbell from "../components_v2/ShowCameraDoorbell";
import RNRestart from "react-native-restart";

const axios = require("axios").default;
const httpClient = axios.create();

const initState = {
  serverUrl: null,
  sessionId: "",
  connected: true,
  showSplashScreen: false,
  isKioskMode: false,
  buildings: [],
  servers: [],
  currentServer: {},
  currentBuilding: {},
  messageToast: {},
  waitingCameraId: undefined,
  announcement: null,
};

const AppReducer = (state = initState, action) => {
  const _state = { ...state };
  var parsedData = null;
  if (action.payload && action.payload.data) {
    parsedData = JSON.parse(action.payload.data);
  }
  switch (action.type) {
    case Pre.APP + Actions.ALL:
      // get global data like profile building name, etc...
      break;
    case Pre.APP + Actions.UPDATE_SESSION:
      let { sessionId } = JSON.parse(action.payload.data);
      if (sessionId) {
        _state.sessionId = sessionId;
        SecureStore.setItemAsync(CONSTS.SESSION_ID, sessionId).catch(
          console.log
        );
      }
      break;
    case Pre.APP + Actions.CONNECTED:
      _state.connected = true;
      break;
    case Pre.APP + Actions.DISCONNECTED:
      _state.connected = false;
      break;
    case Pre.APP + Actions.SHOW_SPLASHSCREEN:
      _state.showSplashScreen = action.payload.isShow;
      break;
    case Pre.APP + Actions.SUBMIT_LOG:
      let { message, level, code } = action.payload;
      let { serverUrl } = _state;
      AppLog(httpClient, serverUrl, message, level, code);
      break;

    case Pre.APP + Pre.BUILDING + Actions.UPDATE:
      // console.log("update current building data", action.payload);
      // SecureStore.Buildings.addBuilding(action.payload).catch((error) =>
      //   console.log("error update building in AppReducer", error)
      // );
      _state.currentBuilding = action.payload;
      break;
    case Pre.USER + Actions.LOGOUT:
    case Actions.LOGOUT:
      console.log("LOGOUT action received!");
      // === Update currentServer ===
      const _currentServer = new ServerInfo(
        _state.currentServer.serverId,
        _state.currentServer.publicAddress,
        _state.currentServer.localAddress,
        "",
        _state.currentServer.userFullName,
        _state.currentServer.userId,
        _state.currentServer.websocketPort
      );
      _state.currentServer = _currentServer;

      SecureStore.Servers.clearToken(_state.currentServer?.serverId);
      SecureStore.deleteAccessToken(_state.currentBuilding?.buildingId);
      // === Clear accessToken ===

      const findBuildings = _state.buildings.map((building) => {
        return (
          (building?.serverId === _state.currentServer.serverId ||
            building?.cloudServerId === _state.currentServer.serverId) &&
          building
        );
      });
      let servers = _state.servers;
      if (findBuildings.length > 0) {
        servers.forEach((elementServer) => {
          findBuildings.forEach((elementBuilding) => {
            if (
              elementServer.serverId === elementBuilding.serverId ||
              elementServer.serverId === elementBuilding.cloudServerId
            ) {
              elementServer.accessToken = "";
              servers[servers.indexOf(elementServer)] = elementServer;
            }
          });
        });
        _state.servers = servers;
      }

      // === remove building ===
      SecureStore.Buildings.removeBuildingByServerId(
        _state.currentServer?.serverId
      ).catch((err) => console.log(err));
      var _buildings = [..._state.buildings];
      if (_state.currentServer.serverId) {
        _buildings = _buildings.filter((building) => {
          return (
            building.serverId !== _state.currentServer?.serverId &&
            building.cloudServerId !== _state.currentServer?.serverId
          );
        });
      }
      _state.buildings = _buildings;

      // _state.currentBuilding = null;
      // SecureStore.deleteItemAsync(CONSTS.BUILDING_ID);
      SecureStore.deleteItemAsync(CONSTS.ACCESS_TOKEN);
      SecureStore.deleteItemAsync(CONSTS.USER_QUICK_ACCESS);

      if (RNRestart) {
        RNRestart.Restart && RNRestart.Restart();
      } else {
        window?.location.reload();
      }
      break;
    // === Update ServerUrl ===
    case Pre.APP + Actions.UPDATE_SERVER_URL:
      if (action.payload) {
        _state.serverUrl = action.payload;
        SecureStore.setItemAsync(CONSTS.SERVER_URL, action.payload).catch(
          (err) => console.log("err add serverUrl  :>> ", err)
        );
      }
      break;
    // === Kiosk Mode (tablet & landscape mode) ===
    case Actions.IS_KIOSK_MODE:
      _state.isKioskMode = action.payload.isKioskMode;
      break;
    // === Servers and Buildings ===
    case Pre.APP + Actions.GET_SERVER_LIST:
      _state.servers = action.payload;
      break;
    case Pre.APP + Actions.GET_BUILDING_LIST:
      _state.buildings = action.payload;
      break;
    case Pre.APP + Actions.GET_CURRENT_BUILDING:
      _state.currentBuilding = action.payload;
      break;
    case Pre.APP + Actions.SET_BUILDINGS:
      var buildings = _state.buildings;
      if (action.payload) {
        // action.payload?.forEach((element) => {
        //   const findBuilding = buildings.find(
        //     (building) => building.buildingId === element.buildingId
        //   );
        //   if (findBuilding) {
        //     buildings[buildings.indexOf(findBuilding)] = element;
        //   } else {
        //     buildings.push(element);
        //   }
        // });
        // === Delete building for empty list ===
        //   const buildingFiltered = buildings.filter((building) => {
        //     if (
        //       building?.serverId === _state.currentServer?.serverId ||
        //       building?.cloudServerId === _state.currentServer?.serverId
        //     ) {
        //       return building;
        //     }
        //   });
        //   if (buildingFiltered.length !== 0) {
        //     const filterBuildingList = buildings.filter(
        //       (building) =>
        //         building.buildingId !== buildingFiltered[0].buildingId
        //     );
        //     if (filterBuildingList.length !== 0) {
        //       buildings = filterBuildingList;
        //     }
        //   }
        // let newArray = !checkIPAddress(_state.serverUrl)
        //   ? _state.buildings.filter((currentBuilding) =>
        //       action.payload?.some(
        //         (newBuilding) =>
        //           currentBuilding.serverId !== newBuilding.serverId &&
        //           currentBuilding.cloudServerId !== newBuilding.cloudServerId
        //       )
        //     )
        //   : _state.buildings;
        var newArray = null;
        if (!checkIPAddress(_state.serverUrl)) {
          newArray = _state.buildings.filter((currentBuilding) =>
            action.payload?.some(
              (newBuilding) =>
                currentBuilding.serverId !== newBuilding.serverId &&
                currentBuilding.cloudServerId !== newBuilding.cloudServerId
            )
          );
        } else if (action.payload.length == 0) {
          newArray = _state.buildings.filter(
            (building) =>
              building.buildingId !== _state.currentBuilding?.buildingId
          );
        } else {
          newArray = _state.buildings;
        }
        buildings = [...newArray, ...action.payload];
        buildings = buildings.filter(
          (elem, index, self) =>
            self.findIndex((t) => {
              return t?.buildingId === elem?.buildingId;
            }) === index
        );
        // console.log("newArray reducer", newArray);
        SecureStore.Buildings.addBuildings(buildings).catch((err) => {
          console.log(err);
        });
        _state.buildings = buildings;
      }
      break;
    case Pre.APP + Actions.SET_SERVERS:
      let setServers = [..._state.servers];
      if (action.payload) {
        action.payload?.forEach((element) => {
          const someDefaultServer = setServers?.find(
            (server) => server.serverId === "defaultServer"
          );
          const findServer = setServers?.find(
            (server) => server.serverId === element.serverId
          );
          if (someDefaultServer) {
            setServers[setServers.indexOf(someDefaultServer)] = element;
          } else if (findServer) {
            setServers[setServers.indexOf(findServer)] = element;
          } else {
            setServers.push(element);
          }
        });
        setServers = setServers.filter(
          (elem, index, self) =>
            self.findIndex((t) => {
              return t.serverId === elem.serverId;
            }) === index
        );
      }
      SecureStore.Servers.setServers(setServers).catch((error) =>
        console.log("error in setBuildings", error)
      );
      _state.servers = setServers;
      break;
    case Pre.APP + Actions.UPDATE_CURRENT_BUILDING:
      SecureStore.setBuildingId(action.payload?.buildingId).catch((e) =>
        console.log("e in set buildingId", e)
      );
      _state.currentBuilding = action.payload;
      break;
    case Pre.APP + Actions.UPDATE_CURRENT_SERVER:
      // SecureStore.setItemAsync(
      //   CONSTS.SERVER_URL,
      //   action.payload?.publicAddress || action.payload?.localAddress
      // ).catch((e) => console.log("e in set serverUrl", e));
      // console.log("update current server", action.payload);
      _state.currentServer = action.payload;
      break;
    case Pre.APP + Actions.REMOVE_BUILDING:
      // console.log("update servers", action.payload);
      SecureStore.Buildings.removeBuilding(action.payload).catch((err) =>
        console.log(err)
      );
      var _buildings = [..._state.buildings];
      if (action.payload) {
        _buildings = _buildings.filter((building) => {
          return building.serverId !== action.payload;
        });
      }
      _state.buildings = _buildings;
      break;
    case Pre.APP + Actions.ADD_SERVER:
      SecureStore.Servers.addServer(action.payload);
      let _servers = [..._state.servers];
      const someServerInfo = _servers.find(
        (server) => server?.serverId == action.payload?.serverId
      );
      if (someServerInfo) {
        _servers[_servers.indexOf(someServerInfo)] = action.payload;
      } else {
        _servers.push(action.payload);
      }
      _state.servers = _servers;
      break;
    case Pre.APP + Actions.ADD_BUILDING:
      if (action.payload) {
        SecureStore.Buildings.addBuilding(action.payload);
        var _buildings = [..._state.buildings];
        const someBuildingInfo = _buildings.find(
          (building) => building?.buildingId === action.payload?.buildingId
        );
        if (someBuildingInfo) {
          _buildings[_buildings.indexOf(someBuildingInfo)] = action.payload;
        } else {
          _buildings.push(action.payload);
        }
        _state.buildings = _buildings;
      }
      break;
    // === Notification ===
    case Pre.APP + Actions.MESSAGE_TOAST:
      if (action.payload || parsedData) {
        _state.messageToast = translate(parsedData || action.payload);
      }
      break;
    case Pre.APP + Actions.CLEAR_MESSAGE_TOAST:
      _state.messageToast = {};
      break;
    // === user joined ===
    case Actions.USER_JOINED:
      const { fullName } = parsedData;
      var toastDetail = {
        title: translate("building.userJoined"),
        variant: "top-accent",
        status: "info",
        description: (
          <>
            <Text style={{ marginBottom: 10, fontSize: 11 }}>
              {translate("building.userJoinedDescription", {
                fullName: fullName || "",
              })}
            </Text>
            {/* <ArButton
              style={{ flex: 1 }}
              onPress={() => {
console.log('this', this)
                // this.props.navigation.navigate("UserAccess", {
                //   userId: id,
                //   expireDate: expireDate, // will use to check users list or guests list
                // });
              }}
              icon={faUserAlt}
              iconColor={Theme.COLORS.WHITE}
            >
              {translate("user.manageUserAccess")}
            </ArButton> */}
          </>
        ),
        duration: 4000,
        isClosable: true,
        closHandler: true,
      };
      _state.messageToast = toastDetail;
      break;
    // === Update Reducer with change websocket ===
    case Actions.UPDATE_APP_REDUCER:
      if (action.payload && action.payload.accessToken) {
        const { serverId } = action.payload;
        // === find building ===
        const findBuilding = _state.buildings.find((building) => {
          return (
            building.serverId === serverId ||
            building.cloudServerId === serverId
          );
        });
        if (findBuilding) {
          _state.currentBuilding = findBuilding;
        }
        _state.currentServer = action.payload;
      }
      break;
    // === not connected caster controller ===
    case Pre.CONTROLLER + Actions.NOT_CONNECTED:
      var toastDetail = {
        title: translate("app.controllerNotConnected"),
        variant: "top-accent",
        status: "error",
        duration: 3000,
      };
      _state.messageToast = toastDetail;
      break;
    // === Widget ===
    case Pre.APP_WIDGET + Actions.ANNOUNCEMENT:
      if (parsedData) {
        _state.announcement = parsedData.message;
      }
      break;
    case Actions.CLEAR_ANNOUNCEMENT:
      _state.announcement = null;
      break;
    //  === Doorbell ===
    case Pre.NOTIFY + Pre.DOORBELL + Actions.PRESSED:
      if (parsedData) {
        let { cameraId, cameraName } = parsedData;
        let title = translate("device.doorbellPressedNotificationTitle");
        // let data = {
        //   cameraId,
        //   cameraName,
        //   channel: CONSTS.NOTIFICATION_CHANNELS.DOORBELLS,
        // };
        // var toastDetail = {
        //   title,
        //   variant: "top-accent",
        //   status,
        //   description,
        //   duration,   If set to null, toast will never dismiss.
        //   isClosable,
        //   countDown,
        //   scenarioRunUId,
        // };
        const messageModel = {
          title,
          status: "success",
          description: IS_MOBILE ? (
            <ShowCameraDoorbell cameraName={cameraName} cameraId={cameraId} />
          ) : (
            cameraName
          ),
          duration: IS_MOBILE ? 30000 : 5000,
          isClosable: IS_MOBILE,
        };
        _state.messageToast = messageModel;
      }

      break;
    case Actions.SET_CAMERA_ID:
      if (action.payload || parsedData) {
        console.log("action.payload", action.payload);
        _state.waitingCameraId = action.payload.cameraId || parsedData.cameraId;
      }
      break;
    case Pre.DOORBELL + Actions.PRESSED + "_RESET":
      _state.waitingCameraId = undefined;
      _state.messageToast = {};
      // _state.waitingCameraUId = undefined;
      break;
    case "APP_LOG":
      _state.appLog = [..._state.appLog, action.payload];
      break;
    case "APP_LOG_CLEAR":
      _state.appLog = [];
      break;
  }
  return _state;
};

export default AppReducer;
